import { Body, Mono, theme } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled.div``

export const TranscriptParagraph = styled.div`
  display: flex;
  flex-direction: column;
`

export const TranscriptParagraphTime = styled(Mono).attrs({
  level: '2',
  inline: true,
  color: 'GREY_70',
})`
  flex-shrink: 0;
  margin-bottom: 8px;
`

export const TranscriptParagraphText = styled(Body).attrs({
  level: '2',
  maxWidth: 100,
})`
  display: inline;
`

export const TranscriptParagraphLine = styled.span`
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.YELLOW_20};
  }

  &:after {
    content: ' ';
    display: inline;
  }
`
